import moment from 'moment'

import { buildBankAccountsTransactionsInsightWidget } from 'modules/banking/components/Widgets/BankAccountsTransactionsWidget'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'

interface AccountTransactionsInsightsProps {
  currency: string
  locale: string
  accountIds?: string[]
  description?: string
  dateFrom?: Date
  dateTo?: Date
  additionalFilters?: Record<string, { in: string[] }>
}

export const AccountTransactionsInsights = ({
  currency,
  locale,
  accountIds = [],
  description,
  dateFrom,
  dateTo,
  additionalFilters,
}: AccountTransactionsInsightsProps) => {
  const amountFormatter = (value: unknown) =>
    formattedAmount({ amountCents: Number(value), currency, locale: locale })

  const allFilters: Record<string, unknown> = {
    bankAccountId: { in: accountIds },
    ...(description && description.trim() !== '' && { description: { eq: description } }),
  }

  if (dateFrom || dateTo) {
    const bookingDateFilter: { between?: [string, string] } = {}

    if (dateFrom && dateTo) {
      bookingDateFilter.between = [
        moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss'),
        moment(dateTo).format('YYYY-MM-DDTHH:mm:ss'),
      ]
    } else if (dateFrom) {
      bookingDateFilter.between = [
        moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss'),
        moment(dateFrom).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      ]
    } else if (dateTo) {
      bookingDateFilter.between = [
        moment(dateTo).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        moment(dateTo).format('YYYY-MM-DDTHH:mm:ss'),
      ]
    }

    if (bookingDateFilter.between) {
      allFilters.bookingDate = bookingDateFilter
    }
  }

  if (additionalFilters) {
    Object.assign(allFilters, additionalFilters)
  }

  return (
    <DataTableWidgetInsights
      widgets={[
        buildBankAccountsTransactionsInsightWidget({
          filters: allFilters,
          prepareDataArgs: { amountFormatter },
        }),
      ]}
      widgetWidth="full"
    />
  )
}
